import { Directive, input, computed, inject, ElementRef, signal } from '@angular/core';
import { ViewWidget } from '../../../interfaces/view-widget';
import { Stylable } from '../../../directives/stylable';
import { WidgetsDisplayService } from '../services/widgets-display.service';
import { ViewportDimensions } from './viewport-aware.directive';
import { generateRandomId } from '../../../utils/id-generation';

@Directive()
export abstract class WidgetContainer extends Stylable {
  protected readonly widgetsDisplayService = inject(WidgetsDisplayService);
  protected readonly elementRef = inject(ElementRef<HTMLElement>);

  widgets = input<ViewWidget[]>([]);
  maxWidgets = signal<number | undefined>(undefined);

  protected viewportDimensions = signal<ViewportDimensions | null>(null);

  protected processedWidgets = computed(() => {
    const widgets = this.widgets();
    const maxItems = this.maxWidgets();

    const processed = this.getProcessedWidgets(widgets, maxItems);
    return this.addUniqueIds(processed);
  });

  protected abstract getProcessedWidgets(widgets: ViewWidget[], maxItems?: number): ViewWidget[];

  protected onViewportChange(dimensions: ViewportDimensions): void {
    this.viewportDimensions.set(dimensions);
  }

  private addUniqueIds(widgets: ViewWidget[]): (ViewWidget & { id: string })[] {
    return widgets.map(widget => ({
      ...widget,
      id: this.generateWidgetId(widget),
    }));
  }

  private generateWidgetId(widget: ViewWidget): string {
    const title = widget.title || 'widget';
    return `${title.toLowerCase().replace(/\s+/g, '-')}-${this.randomId()}`;
  }

  private randomId(): string {
    return generateRandomId();
  }
}
